import { Col, Row } from 'antd';
import React from 'react';

interface IProp {
    title: string
    content?: string
}

class HistoryItemInfoComponent extends React.Component<IProp, {}> {

    render(): JSX.Element {

        return (
            <Row>
                <Col sm={24} md={24} xl={24}>
                    <p className="goepik-history-header-title">{this.props.title}</p>
                </Col>
                <Col sm={24} md={24} xl={24}>
                    <p>{this.props.content}</p>
                </Col>
            </Row>
        );
    }
};

export default HistoryItemInfoComponent;
